import { createContext } from 'react';

import type {
  AuthenticatedUser,
  AuthStatus,
  LoginPayload,
  LoginResult,
  RegisterPayload,
} from './types';

export interface AuthContextValue {
  status: AuthStatus;
  user: AuthenticatedUser | null;
  /** Non-auth bootstrap error (network/500); 401 is the normal guest path. */
  error: Error | null;
  login: (payload: LoginPayload) => Promise<LoginResult>;
  /** Complete a pending 2FA login challenge with a TOTP or recovery code. */
  verifyTwoFactor: (input: { code?: string; recoveryCode?: string }) => Promise<AuthenticatedUser>;
  register: (payload: RegisterPayload) => Promise<AuthenticatedUser>;
  logout: () => Promise<void>;
  refresh: () => Promise<AuthenticatedUser | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
